import { Id, Identifiable, List, ProjectElementType } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

type Range = {
  min: { type: ProjectElementType; uuid: Id } | null;
  max: { type: ProjectElementType; uuid: Id } | null;
};

function moveProjectElement(httpClient: HttpClient) {
  return (
    projectElementId: Id,
    projectElementType: ProjectElementType,
    parentList: Identifiable<List>,
    range: Range,
    alignDates: boolean,
  ) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/project-elements/${projectElementType}/${projectElementId}/move-in-tree`,
        method: HttpMethods.POST,
        data: {
          targetScopeId: parentList.uuid,
          conserveTime: !alignDates,
          after: range.min
            ? {
                type: range.min.type,
                id: range.min.uuid,
              }
            : null,
        },
      })
      .catch((e) => {
        return Promise.reject(
          mapError(e, {
            startDateOutOfBoundProject: "startDateOutOfBoundProject",
            startDateOutOfBound: "startDateOutOfBound",
            endDateOutOfBoundProject: "endDateOutOfBoundProject",
            endDateOutOfBound: "endDateOutOfBound",
          }),
        );
      });
}

export { moveProjectElement };
